import {
	useNameFormController,
	USER_NAME_FORM,
} from '@dealstack/frontend/admin/pages/Manage/User/ManageUser/NameForm/useNameFormController';
import { StringInput } from '@dealstack/frontend/shared/components/forms/StringInput/StringInput';
import { SaveButton } from '@dealstack/frontend/shared/components/fundament/Button/CommonButtons';
import { DataUserTct } from '@dealstack/shared/lib/generated';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import styled from 'styled-components';

interface Props {
	user?: DataUserTct;
	refreshData: () => void;
}

const NameForm = ({ user, refreshData }: Props) => {
	const { updateNameForm, onNameUpdateSubmit } = useNameFormController(refreshData, user);

	return (
		<div>
			<FormProvider {...updateNameForm}>
				<Row>
					<StringInput label="First Name" name={USER_NAME_FORM.FIRST_NAME} />
					<StringInput label="Last Name" name={USER_NAME_FORM.LAST_NAME} />
					<SaveButton
						disabled={!updateNameForm.formState.isDirty}
						onClick={updateNameForm.handleSubmit(onNameUpdateSubmit)}
					/>
				</Row>
			</FormProvider>
		</div>
	);
};

const Row = styled.div`
	display: flex;
	align-items: end;
	grid-template-columns: 1fr 1fr;
	grid-gap: 1em;
`;
const _NameFormExport = memo(NameForm);

export { _NameFormExport as NameForm };
